import React from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { useColors, ThemeColors } from '../../hooks/useColors';

export function LoadingState() {
  const colors = useColors();
  const styles = createStyles(colors);
  
  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={colors.primary} />
    </View>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.background,
  },
}); 